import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { ShippingType } from "interfaces/shipping-type";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_SHIPPINGS_" }
);

export interface ListShippingsState extends IState {
  data: ShippingType[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: ShippingType[];
}

const INITIAL_STATE: ListShippingsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListShippingsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListShippingsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListShippingsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listShippings = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListShippingsTypes = Types;
export const ListShippingsActions = Creators;
